import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage } from '../../WifiManagementBlockSlice';
import NetworkItem from '../../Partials/NetworkItem/NetworkItem';
import infoIcon from './images/info-icon.svg';

const HomeNetworkPage = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='home-network-page'>

            <div className='title'> צפיה ועדכון שם וסיסמת<br/> רשת  WI-FI</div>

            <NetworkItem item={props.homeNetwork} />

            <div className='bottom-remark-wrapper'>
                <div className='icon-wrapper' style={{backgroundImage:infoIcon.bg()}}></div>
                <div className='text-wrapper'> רשת {window.Config.brand_Name_HE} ביתית תומכת בתדר 2.4 ו- 5 גיגה-הרץ (GHz) GH ומאפשרת למכשירים להתחבר אוטומטית לרשת המיטבית עבור המכשיר. </div>
            </div>

        </div>
    );

};

const mapStateToProps = (state) => {
    return {
        homeNetwork: state.wifiManagementBlock?.networkWiFis.find(x=> x.type == 'Main')
    };
};

const mapDispatchToProps = {
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeNetworkPage);
